export const SET_SEARCH_TERMS = '@OXD/SET_SEARCH_TERMS'
export const TOGGLE_OPEN_STATE = '@OXD/TOGGLE_OPEN_STATE'

export type Action = SetSearchTerms | ToggleOpenState

export interface SetSearchTerms {
  type: typeof SET_SEARCH_TERMS
  payload: string
}

export interface ToggleOpenState {
  type: typeof TOGGLE_OPEN_STATE
  payload: boolean
}
